import { render } from "./QuizStep3.vue?vue&type=template&id=01d71c20"
import script from "./QuizStep3.vue?vue&type=script&lang=js"
export * from "./QuizStep3.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__